import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Paper,
  Grid,
  Divider,
} from "@mui/material";
import { RoomService, AttachMoney } from "@mui/icons-material";
import { WSIcons } from "../../commonFunctions/iIcons";
import { OthersOperation } from "./OthersOperation/OthersOperation";

const Others: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(false); // State to control the dialog
  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  return (
    <Paper >
     <Grid container alignItems="center" justifyContent="space-between" padding={"2rem"}>
        <Grid item>
          <Typography variant="h6">Other's</Typography>
        </Grid>
        <Grid item>
          <WSIcons.AppsIcon onClick={handleDialogOpen}/>
        </Grid>
      </Grid>
      
      {/* Divider Component */}
      <Divider sx={{ marginBottom: "0.5rem" }} />

      <List sx={{padding:1}}>
        <ListItem button>
          <ListItemIcon>
            <WSIcons.Reservations />
          </ListItemIcon>
          <ListItemText primary="Reservations" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <WSIcons.Groups2Icon />
          </ListItemIcon>
          <ListItemText primary="Waiting List" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <WSIcons.PaymentsIcon />
          </ListItemIcon>
          <ListItemText primary="Pay Outs" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <WSIcons.Dollar />
          </ListItemIcon>
          <ListItemText primary="Misc. Sales" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <WSIcons.PaymentsIcon />
          </ListItemIcon>
          <ListItemText primary="Account Payment" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <WSIcons.Tasktable />
          </ListItemIcon>
          <ListItemText primary="Take Table" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <WSIcons.SyncIcon />
          </ListItemIcon>
          <ListItemText primary="Transfer Table" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <WSIcons.CreditCardIcon />
          </ListItemIcon>
          <ListItemText primary="Card Top Up" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <WSIcons.TokenIcon />
          </ListItemIcon>
          <ListItemText primary="Reset Token" />
        </ListItem>
      </List>
      <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%',marginTop:'8rem'}}>
        <Typography variant="body1"><WSIcons.DisabledByDefaultIcon sx={{color:"red"}}/>Turn Off</Typography>
      </Grid>
      <OthersOperation open={dialogOpen} onClose={handleDialogClose}/>

    </Paper>
  );
};

export default Others;
